export default "__VITE_ASSET__HYE1NGtr__"